/* eslint-disable import/no-unresolved */
// eslint-disable-next-line import/no-unresolved
const shipping = require('base/checkout/shipping');
const formHelpers = require('../components/form');

const updateSelectLabels = (select) => {
    if (select.val() === '' || select.val() === null) {
        select.addClass('empty');
    } else {
        select.removeClass('empty');
    }
};

function updateCountrySelect() {
    const countryCode = $('#countryCodeGeo').val();
    const isFormVisible = $('.shipping-address-block').is(':visible') || $('.billing-address').is(':visible');
    const countrySelector = $('.billing-address').is(':visible') ? $('#billingCountry') : $('.shippingCountry');
    const countryValue = countrySelector.val();

    if (countryCode !== undefined && isFormVisible && countryValue === '') {
        countrySelector.val(countryCode);
        countrySelector.trigger('change');
    }
}

function updateStatesHTML(response, state, identPage, idenState) {
    const $container = $(state);
    const containerParentWrapper = $container.parent().closest('.form-group');

    if (response.renderedTemplate.indexOf('custom-select') !== -1) {
        containerParentWrapper.addClass('form-group-select');
    } else {
        containerParentWrapper.removeClass('form-group-select');
    }

    $container.html('');
    $container.replaceWith(response.renderedTemplate);

    updateSelectLabels($container);
    if (response.renderedTemplateZip) {
        if (identPage === 'account') {
            $('#zipCode').html('').replaceWith(response.renderedTemplateZip);
        } else if (identPage === 'shipping') {
            $(`#shippingZipCode-${idenState}`).html('').replaceWith(response.renderedTemplateZip);
        } else if (identPage === 'billing') {
            $('#billingZipCode').html('').replaceWith(response.renderedTemplateZip);
        }
    }
    if (response.renderedTemplatePhone) {
        if (identPage === 'account') {
            $('#phone').html('').replaceWith(response.renderedTemplatePhone);
        } else if (identPage === 'shipping') {
            $(`#shippingPhoneNumber-${idenState}`).html('').replaceWith(response.renderedTemplatePhone);
        } else if (identPage === 'billing') {
            $('#phoneNumber').html('').replaceWith(response.renderedTemplatePhone);
        }
    }
}

module.exports = {
    updateCountryByGEO() {
        $(document).ready(() => {
            updateCountrySelect();
        });
    },
    stateEvents() {
        $('#billingAddressSelector').on('change', () => {
            const optionSelected = $('#billingAddressSelector option:selected');
            const countryCode = optionSelected.data('country-code');
            if (countryCode) {
                const stateCode = optionSelected.data('state-code');
                const zipCode = optionSelected.data('postal-code');
                const phone = optionSelected.data('phone');
                this.updateStates(countryCode, '#billingCountry', '#billingState', 'billing', stateCode, zipCode, phone);
            }
        });

        $('[id^="shippingCountry"]').on('change', (e) => {
            const thisTarget = $(e.currentTarget);
            const countryCode = thisTarget.val();
            this.updateStates(countryCode, `#${thisTarget.attr('id')}`, `#${thisTarget.closest('.row').find('[id^="shippingState-"]').attr('id')}`, 'shipping', null, $('#shippingZipCode').val(), $('#shippingPhoneNumber-default').val());
            updateSelectLabels(thisTarget);
        });

        $('.btn-show-details, .btn-add-new').on('click', (ev) => {
            if ($(ev.currentTarget).hasClass('btn-add-new')) {
                setTimeout(() => {
                    updateCountrySelect();
                }, 300);
            }
        });

        $('#billingCountry').on('change', (e) => {
            const thisTarget = $(e.currentTarget);
            const countryCode = thisTarget.val();
            this.updateStates(countryCode, `#${thisTarget.attr('id')}`, '#billingState', 'billing', null, $('#billingZipCode').val(), $('#phoneNumber').val());
            updateSelectLabels(thisTarget);
        });

        $('#country').on('change', () => {
            const countryCode = $('#country').val();
            this.updateStates(countryCode, '#country', '#state', 'account', null, $('#zipCode').val(), $('#phone').val());
        });
    },
    updateStates(countryCode, address, state, identPage, stateSelected, zipCodeVal, phoneVal) {
        if (identPage) {
            const idenState = identPage === 'shipping' ? state.replace('#shippingState-', '') : state.replace('#billingState-', '');
            let url = $(address).data('url');
            let updateStatesHTMLExecuted = false;
            if (stateSelected && stateSelected !== 'undefined') {
                url += `&stateSelected=${stateSelected}`;
            }
            $.ajax({
                url,
                type: 'GET',
                data: {
                    country: countryCode,
                    identPage,
                    idenState,
                    zipValue: zipCodeVal || '',
                    phoneValue: phoneVal || '',
                },
            }).done((response) => {
                if (response.reload) {
                    window.location.href = response.reload;
                } else {
                    const adyenActivated = $('#adyenActivated').val();
                    if (identPage === 'shipping' && adyenActivated && adyenActivated !== 'false') {
                        const previousCountryCode = $('#checkout-main').data('countrycode');
                        if (previousCountryCode && previousCountryCode !== countryCode) {
                            window.location.reload();
                        } else {
                            updateStatesHTML(response, state, identPage, idenState);
                            updateStatesHTMLExecuted = true;
                        }
                    } else {
                        updateStatesHTML(response, state, identPage, idenState);
                        updateStatesHTMLExecuted = true;

                        if (identPage === 'shipping') {
                            $('#checkout-main').data('countrycode', countryCode);
                        }
                    }
                }
                formHelpers.inputFocus();
            }).then(() => {
                const adyenActivated = $('#adyenActivated').val();
                console.log('checkout - update shipping list from update states');
                if (identPage === 'shipping' && adyenActivated === 'false') {
                    shipping.updateShippingList();
                } else if (updateStatesHTMLExecuted === true) {
                    shipping.updateShippingList();
                }
            });
        }
    },
};
